import _auth from './auth'
import _user from './user'
import _client from './client'
import _site from './site'
import _customField from './customField'
import _zone from './zone'
import _asset from './asset'
import _barcode from './barcode'
import _risk from './risk'
import _assetType from './assetType'
import _imports from './imports'
import _checkPredefinedComments from './checkPredefinedComments'
import _checklist from './checklist'
import _check from './check'
import _jobType from './jobType'
import _job from './job'
import _role from './role'
import _inspection from './inspection'
import _dashboard from './dashboard'
import _assetGroup from './assetGroup'
import _company from './company'
import _schedule from './schedule'
import _common from './common'
import _recurringJob from './recurringJob'
import _subscription from './subscription'
import _documents from './documents'
import _ability from './ability'
import _sensor from './sensor'
import _namingConventions from './namingConventions'
import _dynamicStatus from './dynamicStatus'
import _assetTransfer from './assetTransfer'

export let auth = _auth
export let user = _user
export let client = _client
export let site = _site
export let customField = _customField
export let zone = _zone
export let asset = _asset
export let sensor = _sensor
export let risk = _risk
export let barcode = _barcode
export let assetType = _assetType
export let checkPredefinedComments = _checkPredefinedComments
export let checklist = _checklist
export let check = _check
export let jobType = _jobType
export let job = _job
export let role = _role
export let inspection = _inspection
export let dashboard = _dashboard
export let assetGroup = _assetGroup
export let company = _company
export let schedule = _schedule
export let common = _common
export let recurringJob = _recurringJob
export let subscription = _subscription
export let documents = _documents
export let ability = _ability
export let imports = _imports

export let namingConventions = _namingConventions
export let dynamicStatus = _dynamicStatus
export let assetTransfer = _assetTransfer
